import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)

type Props = {
    // buttonText: string,
}
export const AcceptButton: React.FC<Props> = (props) => {
    const AcceptButtonComponent = styled.button`
        background: #FDBA66;
        border-radius: 40px;
        color: #FFFBFB;
        font-weight: bold;
        font-size: 16px;
        line-height: 29px;
        width: 288px;
        height: 37px;
        &:hover:{
          opacity: 0.8;
        }
    `;
  return (
        <AcceptButtonComponent id="acceptButton" type="button">受け取る</AcceptButtonComponent>
    );
  };